<script>

  import { _ } from 'svelte-i18n'
  import { createEventDispatcher } from 'svelte'
  import { tags_are_being_edited } from '../stores'

  export let active = false
  export let outline = false
  export let disabled = false
  export let rectangular = false

  let just_toggled = false

  const dispatch = createEventDispatcher()

  function handleClick() {
    just_toggled = true
    dispatch('click')
  }

</script>

<button  
  on:click={handleClick}
  on:mouseleave={() => {just_toggled = false}}
  class = "pill"
  class:active
  class:outline
  class:disabled
  class:rectangular
  class:just_toggled
  >
  <slot/>
  {#if $tags_are_being_edited && !outline}
    <button on:click|stopPropagation={() => dispatch('delete')} class="pill_action delete" title="{$_('buttons.delete')}">×</button>
    <button on:click|stopPropagation={() => dispatch('rename')} class="pill_action rename" title="{$_('buttons.rename')}">✎</button>
  {/if}
</button>

<style>
  .pill {
    height: 3rem;
    margin: 0 1rem 1rem 0;
    padding: 0 1rem;
    line-height: 3rem;
    background-color: var(--c-pill-bg);
    border: none;
    outline: none;
    border-radius: 1.5rem;
    color: var(--c-text);
    font-family: var(--PensumSans);
    font-weight: 500;
    transition-property: background-color, border-color;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-function);
  }
  .pill:not(.just_toggled):hover {
    color: var(--c-text-hover);
    background-color: var(--c-pill-bg-hover);
    border-color: var(--c-pill-bg-hover);
  }

  .pill.active {
    background-color: var(--c-pill-bg-active);
    color: var(--c-text-on-fill-hover);
  }
  .pill.active:not(.just_toggled):hover {
    background-color: var(--c-pill-bg-hover);
  }

  .pill.outline {
    border: 2px solid var(--c-pill-bg);
    background-color: transparent;
    line-height: 2.6rem;
  }
  .pill.outline:not(.just_toggled):hover {
    background-color: transparent;
    border-color: var(--c-pill-bg-hover);
  }

  .pill.outline.active {
    border-color: var(--c-accent);
    color: var(--c-accent);
  }
  .pill.outline.active:hover:not(.just_toggled) {
    background-color: transparent;
    border-color: var(--c-pill-bg-hover);
  }
  .pill.rectangular {
    border-radius: 0rem;
  }
  .pill.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  .pill_action {
    display: block;
    float: right;
    margin: 0.3rem 0.3rem 0.3rem 0;
    width: 2.4rem;
    height: 2.4rem;
    background-color: transparent;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 1.5rem;
    outline: none;
    color: var(--c-text);
    font-size: 1.8rem;
    line-height: 2.4rem;
  }
  .pill_action:hover {
    border-color: transparent;
  }
  .pill.active .pill_action {
    color: var(--c-text-on-fill);
  }
  .rename {
    margin-left: 0.6rem;
  }
  .delete {
    margin-right: -0.6rem;
  }
  .rename:hover,
  .rename:focus {
    background-color: var(--c-button-bg);
    color: var(--c-text-on-fill);
  }
  .delete:hover,
  .delete:focus {
    background-color: var(--c-danger);
    color: var(--c-text-hover);
  }
</style>